// Valores de tipo para Carousel
export const CAROUSEL_TYPES = {
  DEMO: 'demo',
  SPEAKERS: 'speakers',
  STORIES: 'stories',
};
